'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var choose = exports.choose = function choose(predicate, left, right) {
    return predicate ? left : right;
};
var chooseSingular = exports.chooseSingular = function chooseSingular(count, left, right) {
    return choose(count === 1, left, right);
};
var SPACE = exports.SPACE = ' ';

var pluralise = exports.pluralise = function pluralise(string, count) {
    return chooseSingular(count, string, string + 's');
};

var listSeparator = exports.listSeparator = function listSeparator(i, count) {
    if (i === count - 2) return ' and ';
    if (i >= count - 1) return '';
    return ', ';
};

var slugify = exports.slugify = function slugify() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var replaceSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
    return str.toString().toLowerCase().replace(/\s+/g, replaceSpace).replace(/\-\-+/g, replaceSpace).replace(/[^\w\-]+/g, '').replace(/^-+/, '').replace(/-+$/, '');
};

var cleanEmail = exports.cleanEmail = function cleanEmail() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return str.toString().toLowerCase().replace(/\s+/g, '');
};

var stringValue = function stringValue(value) {
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Array.isArray(value)) return value.join(',');
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') return JSON.stringify(value);
    return value ? value.toString() : '';
};

var chunkString = exports.chunkString = function chunkString(string, chunkSize) {
    var ret = [];
    var length = string.length;

    for (var i = 0; i < length; i += chunkSize) {
        ret.push(string.substr(i, chunkSize));
    }

    return ret;
};

// takes an object map and returns a query string
// @input: { filter_ids=[abc,123], filter_after: 1245 }
// @output: 'filter_ids=abc,123&filter_after=1234'
var createQueryString = exports.createQueryString = function createQueryString(queryObject) {
    if (!queryObject) return '';

    return Object.keys(queryObject).map(function (key) {
        return key + '=' + stringValue(queryObject[key]);
    }).join('&');
};


//////////////////
// WEBPACK FOOTER
// ./src/common/utils/stringUtil.js
// module id = 58
// module chunks = 0